import React, { memo } from 'react';
import Styles from './header-styles.scss';
import { currentAccountStateQuery } from '@/presentation/components';
import { useLogout } from '@/presentation/hooks';
import { useRecoilValue } from 'recoil';
import LogoAuth2 from '../logo/logoAuth2';
const Header = () => {
    const logout = useLogout();
    const currentAccount = useRecoilValue(currentAccountStateQuery);
    const buttonClick = (event) => {
        event.preventDefault();
        logout();
    };
    return (React.createElement("header", { className: Styles.headerWrap },
        React.createElement("div", { className: Styles.headerContent },
            React.createElement(LogoAuth2, null),
            React.createElement("div", { className: Styles.logoutWrap },
                React.createElement("span", { "data-testid": "username" }, currentAccount && currentAccount.attributes.given_name),
                React.createElement("a", { "data-testid": "logout", href: "#", onClick: buttonClick }, "Logout")))));
};
export default memo(Header);
